<div *ngFor="let emoji of emojis">
  <button (click)="onEmojiClick(emoji.name)">{{ emoji.code }}</button>
</div>
